<script lang="ts" setup>
// @ts-ignore
import { SplideSlide } from '@splidejs/vue-splide'
import type { SliderImage } from '~~/server/api/pagebuilder'

export interface PagebuilderSliderProps {
    data: {
        slider_images: SliderImage[]
    }
}
const props = defineProps<PagebuilderSliderProps>()
const data = computed<BlogPost[]>(() =>
    props.data.slider_images.map((slide, index): BlogPost => {
        return {
            id: index,
            title: slide.slider_images_title,
            slug: slide.slider_images_cta,
            category: {
                title: slide.slider_images_tag,
            },
            featured_images: {
                path: slide.slider_images_image,
                alt: slide.slider_images_image_alt,
            },
            targetBlank: slide.slider_images_target_blank,
        }
    })
)
const sliderOptions = {
    pagination: true,
    arrows: true,
    gap: '3rem',
    drag: true,
    perPage: 3,
    breakpoints: {
        992: {
            drag: true,
            pagination: true,
            gap: '2rem',
            arrows: true,
        },
        768: {
            fixedWidth: '90%',
            perPage: 1,
            gap: '1rem',
        },
    },
}
</script>
<template>
  <Slider
    :options="sliderOptions"
    class="mb-6"
  >
    <SplideSlide
      v-for="(slide, index) in data"
      :key="`wai-${index}`"
      :has-track="false"
      class="pt-2"
    >
      <ArticleBox
        :data="slide"
        link-type="url"
        :target="slide.targetBlank"
      />
    </SplideSlide>
  </Slider>
</template>
